import React, { useCallback } from "react";
import { useForm } from "react-final-form";
import classNames from "classnames";
import Input from "rs-components/Input";
import CheckBoxInput from "rs-components/Input/components/CheckBoxInput";
import { ParameterFormFields } from "../../../../../..";
import TextTruncate from "components/TextTruncate";
import HiddenInput from "rs-components/Input/components/HiddenInput";
import { MIN_FLOWS_QUANTITY } from "store/rs-workspace/utils/common.utils";
import { ALTERNATIVE_FLOW_SELECTION_INSTRUCTION } from "shared/labels";
import * as styles from "./styles.module.scss";
const AlternativeStepParamConfig = ({ name, parameter, editable, restrictions }) => {
    const form = useForm();
    const isNotEnoughFlowsSelected = (form.getFieldState(`${name}.${ParameterFormFields.flowIds}`)?.value?.length ?? 0) < MIN_FLOWS_QUANTITY;
    const onCheckFlow = useCallback((checked, index) => {
        const flowId = form.getFieldState(`${name}.${ParameterFormFields._flowIdsMapping}`)
            ?.value?.[index]?.id;
        const flowIds = form.getFieldState(`${name}.${ParameterFormFields.flowIds}`)?.value;
        form.batch(() => {
            if (checked && flowId !== undefined) {
                form.change(`${name}.${ParameterFormFields.flowIds}`, [...flowIds, flowId]);
            }
            else {
                form.change(`${name}.${ParameterFormFields.flowIds}`, flowIds?.filter((id) => id !== flowId));
            }
            form.blur(`${name}.${ParameterFormFields.flowIds}`);
        });
    }, [form, name]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(styles.instruction, { [styles.accented]: isNotEnoughFlowsSelected }) }, ALTERNATIVE_FLOW_SELECTION_INSTRUCTION),
        React.createElement(Input, { component: HiddenInput, name: `${name}.${ParameterFormFields._flowIdsMapping}` }),
        React.createElement(Input, { component: HiddenInput, name: `${name}.${ParameterFormFields.flowIds}`, suppressErrors: true, restrictions: restrictions?.FlowIds }),
        React.createElement("div", { className: styles.flows }, parameter.flows?.map((flow, index) => (React.createElement("div", { key: flow.id, className: styles["flows-row"] },
            React.createElement(Input, { component: CheckBoxInput, name: `${name}.${ParameterFormFields._flowIdsSelection}[${index}]`, onChange: (value) => onCheckFlow(value, index), disabled: !editable }),
            React.createElement(TextTruncate, { className: styles.label, text: flow.name })))))));
};
export default AlternativeStepParamConfig;
